import { pruefe, type Befund, type UiVoll } from "@gui-creator/gemeinsam";
import { useMemo } from "react";
import { useKatalog, useStruktur } from "../api/abfragen.ts";
import { findeUi } from "../huelle/pfad.ts";

/** Prüft die UI im Browser, damit Befunde auch vor der Serverantwort stimmen. */
export function useBefunde(ui: UiVoll | undefined): Befund[] {
  const struktur = useStruktur();
  const katalog = useKatalog(ui?.plugin.id);
  return useMemo(() => {
    if (!ui) return [];
    if (!katalog.data || !struktur.data) return ui.befunde;
    const baum = struktur.data;
    return pruefe(ui.daten, katalog.data, { uiExistiert: (id) => !!findeUi(baum, id) });
  }, [ui, katalog.data, struktur.data]);
}

export function befundZahlen(befunde: Befund[]): { fehler: number; warnungen: number; text: string } {
  const fehler = befunde.filter((b) => b.stufe === "fehler").length;
  const warnungen = befunde.length - fehler;
  const teile = [fehler === 0 ? "Keine Fehler" : `${fehler} Fehler`];
  if (warnungen > 0) teile.push(`${warnungen} ${warnungen === 1 ? "Warnung" : "Warnungen"}`);
  return { fehler, warnungen, text: teile.join(" · ") };
}
